import React from "react";

import NextImage from "../common/NextImage";

const RaceCourseLeagueHead = ({ nm = "Racecourse", nor = 0, flag = "/assets/images/flaq.png", link = "/" }) => {
  return (
    <div className="leg_head">
      <h2>
        <a href={link} type="league">
          <i className="icon_flag">
            <NextImage
              src={flag}
              alt={`${nm} flag`}
              width={22}
              height={22}
              priority={false}
            />
          </i>
          <div className="des">
            <span className="name">{nm}</span>
            <span className="sb_inf">({nor} Races)</span>
          </div>
        </a>
      </h2>
    </div>
  );
};

export default RaceCourseLeagueHead;
